import { initProductDetailSwiper } from '../modules/swiper';

(function($, Drupal, drupalSettings) {
  'use strict';
  Drupal.behaviors.productTabs = {
    attach: function(context, settings) {
      // const productBtns = $('.detail-product__weight-item');
      // const productLinks = $('[data-product-link]');

      // if (productBtns.length === 0) return;

      // productBtns.on('click', function() {
      //   const weight = $(this).html();
      //   const product = getProduct(weight);

      //   // change link
      //   productLinks.each(function() {
      //     $(this).toggleClass('visually-hidden', !product.buy_button_url)
      //     $(this).attr('href', product.buy_button_url);
      //   });

      //   // change description list. @deprecated
      //   // productDescription.empty();
      //   // if (product.description.length > 0) {
      //   //   for (let i = 0; i < product.description.length; i++) {
      //   //     productDescription.append('<li><span>' + product.description[i] + '</span></li>');
      //   //   }
      //   // }

      //   // update current class for weight
      //   productBtns.removeClass('current');
      //   productBtns.each(function() {
      //     if ($(this).html() === weight) {
      //       $(this).addClass('current');
      //     }
      //   })

      //   // update sliders
      //   updateSliderImages($('#swiperDetailProductMain'), product.images);
      //   updateSliderImages($('#swiperDetailProductThumbs'), product.images, true);
      //   updateSliderImages($('#swiperModalDetailProductMain'), product.images, false, true);
      //   updateSliderImages($('#swiperModalDetailProductThumbs'), product.images, true);
      //   initProductDetailSwiper();
      // });

      // const productsArr = drupalSettings.variations_data;
      // function getProduct(weight) {
      //   let product;
      //   for (let i = 0; i < productsArr.length; i++) {
      //     if (productsArr[i].weight === weight) {
      //       product = Object.assign(productsArr[i]);
      //       break;
      //     }
      //   }
      //   return product;
      // }

      // function updateSliderImages(slider, images, isThumb, isZoom) {
      //   const swiperWrapper = slider.find($('.swiper-wrapper'))
      //   swiperWrapper.empty();
      //   for (let i = 0; i < images.length; i++) {
      //     if (isThumb) {
      //       swiperWrapper.append(
      //         '<div class="swiper-slide" data-slide-index="' + Number(i + 1) + '">' +
      //           '<img src="' + images[i]['90x90'] + '"/>' +
      //         '</div>'
      //       );
      //     } else if (isZoom) {
      //       swiperWrapper.append(
      //         '<div class="swiper-slide" data-slide-index="' + Number(i + 1) + '">' +
      //           '<div class="swiper-slide__image">' +
      //             '<div class="swiper-zoom-container">' +
      //               '<img src="' + images[i].url + '"/>' +
      //             '</div>' +
      //           '</div>' +
      //           '<div class="swiper-lazy-preloader"></div>' +
      //         '</div>'
      //       );
      //     } else {
      //       swiperWrapper.append(
      //         '<div class="swiper-slide" data-slide-index="' + Number(i + 1) + '">' +
      //           '<div class="swiper-slide__image">' +
      //             '<img src="' + images[i].url + '"/>' +
      //           '</div>' +
      //         '</div>'
      //       );
      //     }
      //   }
      // }
    }
  };
})(jQuery, Drupal, drupalSettings);
